import Hidden from '@material-ui/core/Hidden';
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import browser from "assets/EnergyCompany/img/browser.png";
import centerStyle from "./center";

const style = theme => ({
  centeredSection: {
    ...centerStyle(theme),
    color: "black",
  },
  sectionWrapper: {
    alignItems: "center",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  disclaimerText: {
    flex: 1,
    paddingLeft: "50px",
    "& h1": {
      fontWeight: "bold",
    },
    "& p": {
      fontSize: "20px",
      lineHeight: "1.5",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0",
      textAlign: "center",
      "& h1": {
        fontSize: "2.4em",
      },
    },
  },
  imgWrapper: {
    flex: 1,
    "& img": {
      width: "100%",
    },
  },
  main: {
    backgroundColor: "white",
    color: "black",
    padding: "50px 0 30px",
    [theme.breakpoints.down("sm")]: {
      padding: "0",
    },
  },
});

const Section2 = ({ classes }) => (
  <main className={classes.main}>
    <section className={classes.centeredSection}>
      <div className={classes.sectionWrapper}>
        <div className={classes.imgWrapper}>
          <img alt="Browser" className={classes.img} src={browser} />
        </div>
        <div className={classes.disclaimerText}>
          <h1>Energia + Computação</h1>
          <Hidden smDown>
            <p>A Energy Company está conectada com a</p>
            <p>modernização do setor elétrico e preparada para</p>
            <p>atender as novas exigências de um mercado cada</p>
            <p>vez mais dinâmico.</p>
          </Hidden>
          <Hidden mdUp>
            <p>A Energy Company está conectada com a modernização do setor elétrico e preparada para atender as novas exigências de um mercado cada vez mais dinâmico.</p>
          </Hidden>
        </div>
      </div>
    </section>
  </main>
);

Section2.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(style)(Section2);



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/3-section.js